'use client'

import { FormToggleRow } from '@/features/order/order-form/components/widget/order-form-fields'
import { TwapUnitInput } from '@/features/order/order-form/components/widget/twap-unit-input'
import { useNumberInput } from '@/hooks/use-number-format'

interface AdvancedTwapBandToggleProps {
  enabled: boolean
  onEnabledChange: (enabled: boolean) => void
  pct: string
  onPctChange: (value: string) => void
}

/**
 * Price band: one enable toggle + one % input, sent as BOTH upper/lower bounds — the
 * contract (§7) has no one-sided band, and explicitly suggests sending the same value
 * for both when the form only offers one input.
 */
export function AdvancedTwapBandToggle({
  enabled,
  onEnabledChange,
  pct,
  onPctChange,
}: AdvancedTwapBandToggleProps) {
  const pctInput = useNumberInput(pct)

  return (
    <div data-tutorial="band">
      <FormToggleRow
        data-tutorial="pause"
        label="Price band (pause on breach)"
        checked={enabled}
        onCheckedChange={onEnabledChange}
      >
        <TwapUnitInput {...pctInput.bind(onPctChange)} placeholder="1" className="pr-8" unit="%" />
      </FormToggleRow>
    </div>
  )
}
